import React, { Component } from 'react'
import Page from '../../containers/page'

import { Container, Row, Col, Input } from 'reactstrap'

import Isvg from 'react-inlinesvg'

import FormBuilder from '../../components/forms/formBuilder'
import { required } from '../../components/forms/validation'
import Search from '../../components/search'

import notification from '../../assets/svg/notification.svg'
import profile from '../../assets/svg/profile-image.svg'
import moreIcon from '../../assets/svg/more.svg'
import rightIcon from '../../assets/svg/arrow-right.svg'
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';

import {
    getSearchParams,
    generateSearchLink,
    generateSearchLinkMultiple,
} from '../../helpers/linkHelper'
import { API_ENDPOINT } from '../../constants'


class Form extends Component {
    constructor(props) {
        super(props)

        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0,
            },
            items: [],
            areas: [],
            total: 0,
            loading: true,
            categories: [
                {
                    name: "Proizvodnja",
                    value: 1
                },
                {
                    name: "Odrzavanje",
                    value: 2
                },
                {
                    name: "Izgradnja",
                    value: 3
                }
            ],
            subcategories: [
                {
                    name: "Rehabilitacija puteva",
                    value: 1
                },
                {
                    name: "Horizontalna i vertikalna signalizacija",
                    value: 2
                },
                {
                    name: "Uklanjanje vegetacije",
                    value: 3
                },
                {
                    name: "Odrzavanje ostalihi elemenata puta i objekata na putevima",
                    value: 4
                },
            ],
        }
    }

    get = () => {
        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](
                window.fetch,
                this.props.lang,
                this.props[0].match,
                this.state.useState
                    ? this.state.params
                    : getSearchParams(this.props[0].location.search, {
                        entries: 10,
                        page: 0,
                    })
            ).then((data) => {
                this.setState(
                    {
                        ...data,
                        loading: null,
                    },
                    () => {
                        this.props.updateMeta(
                            this.props.generateSeoTags(this.state, this.props.lang)
                        )
                    }
                )
            })
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](
                window.fetch,
                this.props.lang,
                this.props[0].match,
                this.state.useState
                    ? this.state.params
                    : getSearchParams(this.props[0].location.search, {
                        entries: 10,
                        page: 0,
                    })
            ).then((data) => {
                this.setState(
                    {
                        ...data,
                        loading: null,
                    },
                    () => {
                        this.props.updateMeta(
                            this.props.generateSeoTags(this.state, this.props.lang)
                        )
                    }
                )
            })
        }


    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0)
        }

        this.get()
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState(
                {
                    loading: true,
                },
                () => {
                    this.get()
                }
            )
        }

        if (prevProps.menu && prevProps.menu != this.props.menu) {
            this.props.changeCategory(null);
        }
        if (prevProps.category && prevProps.category != this.props.category) {
            this.props.changeSubcategory(null);
        }
    }

    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params
            state.sortField = field
            state.sortType = type
            this.setState({
                params: state,
            })
        } else {
            this.props[0].history.push(
                generateSearchLinkMultiple(
                    this.props[0].location.search,
                    { entries: 10, page: 0 },
                    [
                        { name: 'sortField', value: field },
                        { name: 'sortType', value: type },
                    ],
                    false
                )
            )
        }
    }

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0,
                }
                obj[name] = value
                this.setState({ params: obj })
            } else {
                let obj = this.state.params
                obj[name] = value
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(
                generateSearchLink(
                    this.props[0].location.search,
                    { entries: 10, page: 0 },
                    name,
                    value,
                    restart
                )
            )
        }
    }

    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0,
                }
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value
                }
                this.setState({ params: obj })
            } else {
                let obj = this.state.params
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(
                generateSearchLinkMultiple(
                    this.props[0].location.search,
                    { entries: 10, page: 0 },
                    fields,
                    restart
                )
            )
        }
    }

    insertOrUpdate = (data) => {
        console.log(data)

        // if (data.menu && typeof data.menu != 'string') {
        //     data.menu = data.menu[0]
        // }
        // if (data.category && typeof data.category != 'string') {
        //     data.category = data.category[0]
        // }

        this.setState(
            {
                loading: true,
            },
            () => {
                if (this.props[0].match.params.id == 'new') {
                    fetch(API_ENDPOINT + '/data/news/references/new', {
                        method: 'POST',
                        headers: {
                            'content-type': 'application/json',
                            Authorization:
                                typeof localStorage !== 'undefined'
                                    ? `Bearer ${localStorage.getItem('authToken')}`
                                    : null,
                        },
                        body: JSON.stringify(data),
                    })
                        .then((res) => res.json())
                        .then((result) => {
                            this.props[0].history.push('/references/list')
                        })
                } else {
                    fetch(API_ENDPOINT + '/data/news/references/' + this.props[0].match.params.id, {
                        method: 'PUT',
                        headers: {
                            'content-type': 'application/json',
                            Authorization:
                                typeof localStorage !== 'undefined'
                                    ? `Bearer ${localStorage.getItem('authToken')}`
                                    : null,
                        },
                        body: JSON.stringify(data),
                    })
                        .then((res) => res.json())
                        .then((result) => {
                            this.props[0].history.push('/references/list')
                        })
                }
            }
        )
    }

    delete = (id) => {
        this.setState(
            {
                loading: true,
            },
            () => {
                fetch(API_ENDPOINT + '/data/news/references/' + id, {
                    method: 'DELETE',
                    headers: {
                        'content-type': 'application/json',
                        Authorization:
                            typeof localStorage !== 'undefined'
                                ? `Bearer ${localStorage.getItem('authToken')}`
                                : null,
                    },
                })
                    .then((res) => res.json())
                    .then((result) => {
                        this.get()
                    })
            }
        )
    }

    render() {
        let params = {}
        if (this.state.useState) {
            params = this.state.params
        } else {
            params = getSearchParams(this.props[0].location.search, {
                entries: 10,
                page: 0,
            })
        }
        // console.log(this.props.uData.menu)

        return (
            <div className='page'>
                <Container className='dashboard'>

                    {/* <Row>
                        <Col lg='9'>
                            <Search />
                        </Col>
                        <Col lg='3'>
                            <div className='component notifications'>
                                <div className="component-wrap">
                                    <Isvg src={notification} />
                                    <div className='profile'>
                                        <span className='name color-black'>
                                            {this.props.uData.username}
                                        </span>
                                        <Isvg src={profile} className='profile-image' />
                                        <Isvg src={moreIcon} />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row> */}

                    <FormBuilder

                        onSubmit={(data) => this.insertOrUpdate(data)}
                        initialValues={this.state.initialValues}


                        fields={[
                            {
                                type: 'row',
                                children: [
                                    {
                                        type: 'col',
                                        width: {
                                            lg: 9
                                        },
                                        children: [{
                                            type: 'div',
                                            className: 'main-form',
                                            children: [{
                                                type: 'row',
                                                children: [
                                                    //HEADER
                                                    {//naslov forme
                                                        type: 'col',
                                                        width: {
                                                            lg: 12, sm: 12, xs: 12
                                                        },
                                                        children: [
                                                            {
                                                                type: 'div',
                                                                className: 'form-header',
                                                                children: [
                                                                    {
                                                                        type: 'h5',
                                                                        className: 'component-header',
                                                                        text: 'Dodavanje reference'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    // {//button-i i switch-ovi
                                                    //     type: 'col',
                                                    //     width: {
                                                    //         lg: 9, sm: 12, xs: 12
                                                    //     },
                                                    //     children: [
                                                    //         {
                                                    //             type: 'div',
                                                    //             className: 'form-header-buttons',
                                                    //             children: [
                                                    //                 {
                                                    //                     type: 'div',
                                                    //                     className: 'form-title-buttons',
                                                    //                     children: [
                                                    //                         {
                                                    //                             type: 'switch',
                                                    //                             name: 'isVisible',
                                                    //                             label: 'Aktivna',
                                                    //                         },
                                                    //                         {
                                                    //                             type: 'switch',
                                                    //                             name: 'isPromoted',
                                                    //                             label: 'Izdvojena',
                                                    //                         },
                                                                   

                                                    //                     ]
                                                    //                 }
                                                    //             ]
                                                    //         }
                                                    //     ]
                                                    // },
                                                    //END HEADER
                                                    //FORMA za unos vijesi
                                                    {
                                                        type: 'col',
                                                        width: {
                                                            lg: 12, sm: 12, xs: 12
                                                        },
                                                        children: [
                                                            {
                                                                type: 'text',
                                                                name: 'name',
                                                                label: 'Naslov'
                                                            },
                                                        ]
                                                    },
                                                    {
                                                        type: 'col',
                                                        width: {
                                                            lg: 12, sm: 12, xs: 12
                                                        },
                                                        children: [
                                                            {
                                                                type: 'textarea',
                                                                name: 'shortDescription',
                                                                label: 'Uvodni tekst'
                                                            },
                                                        ]
                                                    },


                                                    {
                                                        type: 'col',
                                                        width: {
                                                            lg: 12, sm: 12, xs: 12
                                                        },
                                                        children: [
                                                            {
                                                                type: 'html',
                                                                name: 'content',
                                                                label: 'Detaljno',
                                                                onChange: {}
                                                            },
                                                        ]
                                                    },
                                                    // {
                                                    //     type: 'col',
                                                    //     width: {
                                                    //         lg: 12, sm: 12, xs: 12
                                                    //     },
                                                    //     children: [
                                                    //         {
                                                    //             type: 'gallery',
                                                    //             name: 'gallery',
                                                    //             label: 'Galerija',
                                                    //             onChange: {}
                                                    //         },
                                                    //     ]
                                                    // },
                                                    {
                                                        type: 'col',
                                                        width: {
                                                            lg: 6, sm: 12, xs: 12
                                                        },
                                                        children: [
                                                            {
                                                                type: 'select',
                                                                name: 'category',
                                                                multiple: false,
                                                                values: this.state.categories.map(item => {
                                                                    return {
                                                                        name: item.name,
                                                                        value: item.value
                                                                    }
                                                                }),
                                                                label: 'Kategorija'
                                                            },
                                                        ]
                                                    },
                                                    
                                                    {
                                                        type: 'col',
                                                        width: {
                                                            lg: 6, sm: 12, xs: 12
                                                        },
                                                        children: [
                                                            {
                                                                type: 'select',
                                                                name: 'subcategory',
                                                                multiple: false,
                                                                values: this.state.subcategories.map(item => {

                                                                    return {
                                                                        name: item.name,
                                                                        value: item.value
                                                                    }

                                                                }),
                                                                label: 'Potkategorija'
                                                            },
                                                        ]
                                                    },
                                                    // {
                                                    //     type: 'col',
                                                    //     width: {
                                                    //         lg: 7, sm: 12, xs: 12
                                                    //     },
                                                    //     children: [
                                                    //         {
                                                    //             type: 'select',
                                                    //             name: 'subcategory',
                                                    //             multiple: false,
                                                    //             values: this.state.subcategories.filter(item => String(this.props.category) == String(item.category)).map(item => {

                                                    //                 return {
                                                    //                     name: item.name,
                                                    //                     value: item._id
                                                    //                 }

                                                    //             }),
                                                    //             label: 'Potkategorija'
                                                    //         },
                                                    //     ]
                                                    // },
                                                    {
                                                        type: 'col',
                                                        width: {
                                                            lg: 6, sm: 12, xs: 12
                                                        },
                                                        children: [
                                                            {
                                                                type: 'submit-button',
                                                                className: 'main-form-button button-1',
                                                                text: this.props[0].match.params.id != 'new' ? 'Izmjeni' : 'Dodaj',
                                                            }
                                                        ]
                                                    }

                                                ]
                                            }]
                                        }
                                        ]
                                    },
                                    //END FORM za unos vijesti
                                    {
                                        type: 'col',
                                        width: {
                                            lg: 3
                                        },
                                        children: [
                                            {//vrijeme objave
                                                type: 'div',
                                                className: 'component customer-age',
                                                children: [
                                                    {
                                                        type: 'h5',
                                                        text: 'Vrijeme objave',
                                                        className: 'component-header'
                                                    },
                                                    {
                                                        type: 'date',
                                                        name: 'date',
                                                    },
                                                    {
                                                        type: 'time',
                                                        name: 'time',

                                                    }

                                                ]
                                            },
                                            {//Slike
                                                type: 'div',
                                                className: 'component gallery',
                                                children: [
                                                    {
                                                        type: 'h5',
                                                        className: 'component-header',
                                                        text: 'Fotografija',
                                                    },
                                                    {
                                                        type: 'image',
                                                        height: 300,
                                                        name: 'image'
                                                    }
                                                ]
                                            },
                                            
                                        ]
                                    }
                                ]
                            }
                        ]}
                    ></FormBuilder>
                </Container>
            </div >
        )
    }
}

const selector = formValueSelector('form');

export default connect(state => {
    return { menu: selector(state, 'menu'),  category: selector(state, 'category') }

}, {
    changeCategory: value => change("form", "category", value),
    changeSubcategory: value => change("form", "subcategory", value),

})(Page(Form));